import RuianList from "entities/ruianList";
import RepositoryBase from "./repositoryBase";

export default class RuianRepository extends RepositoryBase {
  search(text: string, distinct?: "street" | "city" | "city_part", limit = 10, signal?: AbortSignal) {
    const query = { field: text, distinct, limit };
    return this.callApi(api => api.all("ruian/field").getEntity(RuianList, query, { signal }));
  }
}
